import React from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterPanel = ({ 
  searchQuery, 
  onSearchChange, 
  filterStatus, 
  onStatusChange,
  filterInterval,
  onIntervalChange,
  sortBy, 
  onSortChange,
  stats 
}) => {
  return (
    <div className="mb-6 space-y-4">
      {/* Quick Stats */}
      <div className="flex flex-wrap gap-3">
        <button
          onClick={() => onStatusChange('all')}
          className={`
            px-4 py-2 rounded-lg border transition-smooth text-sm font-medium
            ${filterStatus === 'all' ?'bg-primary text-primary-foreground border-primary' :'bg-card text-foreground border-border hover:border-primary/50'
            }
          `}
        >
          All ({stats?.total})
        </button>
        <button
          onClick={() => onStatusChange('active')}
          className={`
            px-4 py-2 rounded-lg border transition-smooth text-sm font-medium
            ${filterStatus === 'active' ?'bg-green-600 text-white border-green-600' :'bg-card text-foreground border-border hover:border-green-600/50'
            }
          `}
        >
          Active ({stats?.active})
        </button>
        <button
          onClick={() => onStatusChange('trialing')}
          className={`
            px-4 py-2 rounded-lg border transition-smooth text-sm font-medium
            ${filterStatus === 'trialing' ?'bg-blue-600 text-white border-blue-600' :'bg-card text-foreground border-border hover:border-blue-600/50'
            }
          `}
        >
          Trialing ({stats?.trialing})
        </button>
        <button
          onClick={() => onStatusChange('past_due')}
          className={`
            px-4 py-2 rounded-lg border transition-smooth text-sm font-medium
            ${filterStatus === 'past_due' ?'bg-amber-600 text-white border-amber-600' :'bg-card text-foreground border-border hover:border-amber-600/50'
            }
          `}
        >
          Past Due ({stats?.pastDue})
        </button>
        <button
          onClick={() => onStatusChange('canceled')}
          className={`
            px-4 py-2 rounded-lg border transition-smooth text-sm font-medium
            ${filterStatus === 'canceled' ?'bg-gray-600 text-white border-gray-600' :'bg-card text-foreground border-border hover:border-gray-600/50'
            }
          `}
        >
          Canceled ({stats?.canceled})
        </button>
      </div>

      {/* Search and Filters */}
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <Input
            placeholder="Search by customer name, email, or plan..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            iconName="Search"
          />
        </div>
        <Select
          options={[
            { value: 'all', label: 'All Intervals' },
            { value: 'monthly', label: 'Monthly' },
            { value: 'yearly', label: 'Yearly' }
          ]}
          value={filterInterval}
          onChange={onIntervalChange}
        />
        <Select
          options={[
            { value: 'newest', label: 'Newest First' },
            { value: 'oldest', label: 'Oldest First' },
            { value: 'amount-high', label: 'Highest Amount' },
            { value: 'amount-low', label: 'Lowest Amount' }
          ]}
          value={sortBy}
          onChange={onSortChange}
        />
      </div>
    </div>
  );
};

export default FilterPanel;